import { z } from 'zod';
import { datetime } from './commons';
//====================================================
// Dossier status enum
//====================================================
export const DossierFinancementStatus = {
    INSTRUCTION: 'INSTRUCTION',
    FININSTRUCTION: 'FININSTRUCTION',
    MISESOUSRAPPORTPREV: 'MISESOUSRAPPORTPREV',
    MISESOUSRAPPORT: 'MISESOUSRAPPORT',
    PRETAVOTER: 'PRETAVOTER',
    VOTE: 'VOTE',
    SOLDE: 'SOLDE',
};
//====================================================
// Dossier event type enum
//====================================================
export const DossierFinancementEventType = {
    DECISION: 'DECISION',
    AVIS_INSTRUCTION: 'AVIS_INSTRUCTION',
    AVENANT: 'AVENANT',
    CLOTURE: 'CLOTURE',
};
//====================================================
// Dossier decision type enum
//====================================================
export const DossierFinancementDecisionType = {
    FAVORABLE: 'FAVORABLE',
    DEFAVORABLE: 'DEFAVORABLE',
};
//====================================================
// Dossier action type
//====================================================
export const dossierFinancementActionSchema = z.object({
    id: z.string(),
    title: z.string(),
    icon: z
        .object({
        icon: z.string(),
    })
        .optional(),
    variant: z.string().optional(),
    disabled: z.boolean().optional(),
    hoverMessage: z.string().optional(),
});
//====================================================
// Dossier financement type
//====================================================
export const DossierFinancementSchema = z.object({
    href: z.string(),
    libelle: z.string().optional(),
    statut: z.string().optional(),
    referenceAdministrative: z.string().optional(),
    history: z
        .object({
        events: z
            .array(z.object({
            type: z.string(),
            date: z.union([datetime, z.string().date()]),
            dateMetier: z.union([datetime, z.string().date()]).optional(),
            avis: z.string().optional(),
        }))
            .optional(),
    })
        .optional(),
    decision: z
        .object({
        valeur: z.string(),
    })
        .optional(),
    dispositif: z
        .object({
        expand: z.object({
            teleservicePaiement: z.object({
                href: z.string(),
            }),
        }),
    })
        .optional(),
    reference: z.string(),
    cloture: z
        .object({
        value: z.boolean(),
    })
        .optional(),
    demandesPaiement: z.array(z.string()).optional(),
    actions: z
        .array(z.object({
        type: z.string(),
        enable: z.boolean().optional(),
    }))
        .optional(),
    hasOngoingPayment: z.boolean().optional(),
    avenant: z
        .object({
        id: z.number(),
    })
        .optional(),
});
export const DossiersFinancementSchema = z.array(DossierFinancementSchema.optional());
//====================================================
// Formatted dossier financement type
//====================================================
export const FormattedDossierFinancementSchema = z.object({
    title: z.string().optional(),
    statut: z.string().optional(),
    teleservicePaiement: z.string().optional(),
    reference: z.string().optional(),
    referenceAdministrative: z.string().optional(),
    href: z.string().optional(),
    actions: z.array(dossierFinancementActionSchema),
    hasOngoingPayment: z.boolean().optional(),
});
export const FormattedDossiersFinancementSchema = z.array(FormattedDossierFinancementSchema.optional());
//# sourceMappingURL=dossiers-financement.js.map